export default __webpack_public_path__ + "static/media/IMG-20210930-WA0000.d63fd4f8.jpg";